<template>
  <roe-error-message :field="design.age_requirement_sync">
    <roe-radio-input
      v-model="design.$model.age_requirement_sync"
      @change="onChange()"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";

export default {
  name: "RoeAgeRequirementSyncRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    onChange() {
      if (+this.design.$model.age_requirement_sync === 1) {
        this.design.$model.age_requirement_match_years = this.design.$model.age_requirement_years;
        this.design.$model.age_requirement_match_months = this.design.$model.age_requirement_months;
      }
    }
  }
};
</script>
